/**
 * Mirrors apps/api/src/modules/identity/merchant-portfolio.service.ts - the only shapes the portfolio routes return.
 * (A portfolio is the set of shops one administrator manages; lots P1-P3.)
 */

/** One line of `GET /admin/portfolios`: an administrator and what it manages - or, with no administrator, the unassigned shops. */
export interface Portfolio {
  /** `null` for the single line that counts the shops nobody manages. */
  readonly adminUserId: string | null;
  readonly email: string | null;
  readonly displayName: string | null;
  readonly adminStatus: string | null;
  readonly merchantCount: number;
  readonly pendingCount: number;
  readonly activeCount: number;
  readonly suspendedCount: number;
  readonly refusedCount: number;
}

/** One entry of `GET /admin/managers`: an ACTIVE platform administrator a shop can be assigned to. */
export interface AssignableAdmin {
  readonly userId: string;
  readonly email: string;
  readonly displayName: string | null;
}

/** What a picker and a table show for an administrator: its name when it has one, else its address. */
export function adminName(admin: {
  readonly displayName: string | null;
  readonly email: string | null;
}): string {
  return admin.displayName ?? admin.email ?? '—';
}
